module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainWork"
  }, [_c('NavTab', {
    staticStyle: {
      "margin-top": "-20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "formBox"
  }, [_c('el-form', {
    ref: "myForm",
    attrs: {
      "model": _vm.query,
      "size": "mini"
    }
  }, [_c('span', {
    staticClass: "formBoxItem"
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "预约编号",
      "prop": "recordNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.recordNo),
      callback: function($$v) {
        _vm.$set(_vm.query, "recordNo", $$v)
      },
      expression: "query.recordNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "预约电话",
      "prop": "reporterPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.reporterPhone),
      callback: function($$v) {
        _vm.$set(_vm.query, "reporterPhone", $$v)
      },
      expression: "query.reporterPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "预约人姓名",
      "prop": "reporterName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.reporterName),
      callback: function($$v) {
        _vm.$set(_vm.query, "reporterName", $$v)
      },
      expression: "query.reporterName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "是否加急",
      "prop": "expedited"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.query.expedited),
      callback: function($$v) {
        _vm.$set(_vm.query, "expedited", $$v)
      },
      expression: "query.expedited"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "是否取消预约",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.query.cancel),
      callback: function($$v) {
        _vm.$set(_vm.query, "cancel", $$v)
      },
      expression: "query.cancel"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "预约时间",
      "prop": "districtId"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "start-placeholder": "开始日期",
      "range-separator": "至",
      "end-placeholder": "结束日期",
      "type": "daterange",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "placeholder": "请选择时间段"
    },
    on: {
      "change": _vm.onSelect
    },
    model: {
      value: (_vm.timeArr),
      callback: function($$v) {
        _vm.timeArr = $$v
      },
      expression: "timeArr"
    }
  }, _vm._l((_vm.optionsTime), function(item) {
    return _c('el-option', {
      key: item.dateDesc,
      attrs: {
        "label": item.dateDesc,
        "value": item.dateDesc
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "案件类型",
      "prop": "recordType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.query.recordType),
      callback: function($$v) {
        _vm.$set(_vm.query, "recordType", $$v)
      },
      expression: "query.recordType"
    }
  }, _vm._l((_vm.caseTypeLists), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getAccidentList
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.command == '超级管理员' || _vm.command == '高级管理员') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportEx
    }
  }, [_vm._v("导出")]) : _vm._e(), _vm._v(" "), (_vm.createState) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showCreate
    }
  }, [_vm._v("创建预约")]) : _vm._e()], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.accidentList,
      "max-height": "460",
      "border": "",
      "tooltip-effect": "dark",
      "header-cell-style": _vm.tableHeaderColor,
      "cell-style": _vm.cellStyle
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "预约编号",
      "show-overflow-tooltip": "",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.recordNo) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约位置",
      "show-overflow-tooltip": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.location) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": "",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.reporterName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约人手机号",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.reporterPhone) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约时间段",
      "show-overflow-tooltip": "",
      "min-width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.appointmentTime) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "车牌号",
      "show-overflow-tooltip": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.carPlate) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驾驶证号",
      "show-overflow-tooltip": "",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.driverLicence) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驾驶证注册时间",
      "show-overflow-tooltip": "",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.driverCardTime) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "行驶证注册时间",
      "show-overflow-tooltip": "",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.vehicleCardTime) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约大队",
      "show-overflow-tooltip": "",
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.organizationName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("orderListFilter")(scope.row.status)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "案件类型",
      "show-overflow-tooltip": "",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.type == 2 ? "一般程序" : "简易程序") + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否加急",
      "show-overflow-tooltip": "",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.expedited == 1 ? "是" : "否") + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "取消原因",
      "show-overflow-tooltip": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.cancelReason) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status < 3 || scope.row.status == 7) ? [_c('span', {
          staticClass: "reMessage",
          on: {
            "click": function($event) {
              return _vm.toDetail(scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c('span', {
          on: {
            "click": function($event) {
              return _vm.getRoomId(scope.row.id, scope.row)
            }
          }
        }, [_vm._v("进入处理")])] : [_c('span', {
          on: {
            "click": function($event) {
              return _vm.getRoomId(scope.row.id, scope.row)
            }
          }
        }, [_vm._v("预约详情")])], _vm._v(" "), (scope.row.payqrStatus == 1) ? [_c('span', {
          staticClass: "qr_p",
          on: {
            "click": function($event) {
              return _vm.showQR(scope.row)
            }
          }
        }, [_vm._v("支付码")])] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.accidentList.length) ? _c('div', {
    staticClass: "pagination"
  }, [_c('nt-pagination', {
    ref: "child",
    on: {
      "fetchData": _vm.getMyAccidentList
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', [(_vm.videoState) ? _c('videoPlat', {
    ref: "videoPlat",
    attrs: {
      "roomId": _vm.roomId
    },
    on: {
      "reStartMask": _vm.reStartMask,
      "startMethod": _vm.startMethod,
      "closeMask": _vm.closeMask
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', [(_vm.videoEasyState) ? _c('videoEasy', {
    ref: "videoEasy",
    attrs: {
      "roomId": _vm.roomId
    },
    on: {
      "reStartMask": _vm.reStartMask,
      "startMethod": _vm.startMethod,
      "closeMask": _vm.closeMask
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "80%",
      "top": "20px",
      "title": "详情",
      "center": "",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('Detail', {
    key: _vm.component_key,
    attrs: {
      "roomId": _vm.roomId,
      "rowItem": _vm.rowItem
    },
    on: {
      "onClose": _vm.onClose
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "30%",
      "title": "罚款支付码",
      "center": "",
      "visible": _vm.imageVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "before-close": _vm.hideQR,
      "destroy-on-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.imageVisible = $event
      }
    }
  }, [(_vm.imageVisible) ? _c('QrImage', {
    key: _vm.component_key,
    attrs: {
      "roomId": _vm.roomId,
      "QRimageUrl": _vm.QRimageUrl
    },
    on: {
      "hideQR": _vm.hideQR
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "50%",
      "top": "0",
      "title": "创建预约单",
      "center": "",
      "visible": _vm.createVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "show-close": false,
      "before-close": _vm.hideCreate,
      "destroy-on-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.createVisible = $event
      }
    }
  }, [(_vm.createVisible) ? _c('Create', {
    key: _vm.component_key,
    on: {
      "hideCreate": _vm.hideCreate
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129e2845","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/weifa/workPlat.vue
// module id = AEXB
// module chunks = 6